var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.desplegar()
    ? _c(
        "vs-dropdown-item",
        {
          staticClass: "menu-accion",
          nativeOn: {
            click: function($event) {
              return _vm.ejecutarAccion()
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "icono" },
            [_c("vs-icon", { attrs: { icon: _vm.icono, size: "small" } })],
            1
          ),
          _c("div", { staticClass: "accion" }, [
            _vm._v(" " + _vm._s(_vm.nombre) + " ")
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }